<div class="itinerarydesc">Sailing the <span class="itinerary">Puget Sound & San Juan Islands</span></div>
